import { cva, cx, type VariantProps } from '@/cva.config';
import type { HTMLAttributes } from 'react';

export const carouselDotVariants = cva({
  base: 'embla__dots flex w-full items-center',
  variants: {
    position: {
      overlaySlides: 'absolute bottom-6 h-3',
      belowSlides: 'mt-6 md:max-lg:mt-10 lg:mt-12',
      none: 'hidden',
    },
    alignment: {
      center: 'justify-center',
      end: 'justify-end',
      start: 'justify-start',
    },
  },
});

interface ReactCarouselDotsProps
  extends VariantProps<typeof carouselDotVariants>,
    HTMLAttributes<HTMLDivElement> {
  scrollSnaps: number[];
  selectedIndex: number;
  onDotButtonClick: (index: number) => void;
}

export const ReactCarouselDots = ({
  alignment = 'center',
  className,
  position,
  scrollSnaps,
  selectedIndex,
  onDotButtonClick,
  ...props
}: ReactCarouselDotsProps) => (
  <div
    className={cx(carouselDotVariants({ position, alignment }), className)}
    {...props}
  >
    {scrollSnaps.map((_, index) => (
      <button
        type="button"
        className={cx(
          'embla__dot',
          index === selectedIndex && 'embla__dot--selected',
        )}
        onClick={() => onDotButtonClick(index)}
        key={index}
      />
    ))}
  </div>
);
